// extracted by mini-css-extract-plugin
var _1 = "rRiiv";
var _2 = "RbDKq";
var _3 = "SHmTv";
var _4 = "wdWLd";
var _5 = "pMMtq";
var _6 = "ejbTF";
var _7 = "goYkZ";
var _8 = "tMEMy";
var _9 = "nC39a";
var _a = "PoXtu";
export { _1 as "addinsBody", _2 as "addinsHeader", _3 as "addinsTitle", _4 as "container", _5 as "copilotChatBody", _6 as "copilotChatHeader", _7 as "editorPane", _8 as "helpBody", _9 as "rolloutOverridesBody", _a as "tipsBody" }
